import gql from 'graphql-tag';

const KEY_ASSESSMENT_ENRICHMENT_REPORT_QUERY = gql`
  query getAssessmentAndEnrichmentActivityReport(
    $where: KeyAssessmentAndEnrichmentActivityReportWhereInput!
    $dateRange: DateRangeInput!
  ) {
    keyAssessmentAndEnrichmentActivityReport(where: $where, dateRange: $dateRange) {
      spotChecks {
        totalCompletedCount
        studentCompletedCount
        averageWpm
        averageAccuracy
      }
      enrichmentActivities {
        hearItTypeIt {
          totalCompletedCount
          studentCompletedCount
        }
        myChoiceKeyboarding {
          totalCompletedCount
          studentCompletedCount
        }
      }
      teacherCreatedActivities {
        totalCompletedCount
        studentCompletedCount
        averageWpm
        averageAccuracy
      }
      assessmentAccelerator {
        modules {
          id
          name
        }
        totalSecondsSpent
        totalFirstAttemptCount
        assignmentStatus
      }
    }
  }
`;

export default KEY_ASSESSMENT_ENRICHMENT_REPORT_QUERY;
